import MuiIconButton, { IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';
import React from 'react';

export interface IconButtonProps extends MuiIconButtonProps {}

export const IconButton = (props: IconButtonProps) => {
  return <MuiIconButton {...props} />;
};
